  <div class="text-center p-lg-3 p-3 bg-white rounded-corners-12 mb-sm-3 mb-2 create-community-card container-shadow">
    <div>
  
      <div class="float-right mt-2 available-options" *ngIf="!isPastCommunity">
        <div ngbDropdown>
          <a class="cursor-pointer" id="community" ngbDropdownToggle>
            <img src="assets/themes/icons/kabab-menu-icon.svg" alt="menu icon" />
          </a>
          <div ngbDropdownMenu aria-labelledby="community" class="ngb-dropdown-list">
            <div  
              routerLink="/community/past-list" 
              (click)="pastCommunity()"
              class="text-left paragraph list-hover p-2 w-100 dropdown-item">
              {{mls.languageText.community.key56}}
            </div>
          </div>
        </div>
      </div>
      <img class="mt-4" src="assets/themes/images/create-community-placeholder.svg" alt="banner" width="202" height="150" />
    </div>
    <div class="mt-3">
      <h6 class="heading-4">
        <span *ngIf="isPastCommunity">{{mls.languageText.community.key56}}</span>
        <span *ngIf="!isPastCommunity"> {{mls.languageText.community.key34}}</span>
      </h6>
      <p *ngIf="!isPastCommunity" class="secondary-paragraph color-grey-500 mb-2"><span class="color-grey-500">{{translations.key6}}</span></p>
      <ol  *ngIf="isPastCommunity" class="secondary-paragraph color-grey-500 mb-2 px-3">
        <li>{{translations.key7}}</li>
        <li>{{translations.key8}}</li>
        <li>{{translations.key9}}</li>
      </ol>
      <p></p>
      <button routerLink="/community/createCommunity"
       (click)="createCommunity()"
        type="button" 
        class="btn-design medium ellipsis filled w-100 mt-3" 
        *ngIf="!isPastCommunity"
        >
        {{mls.languageText.community.key120}}
      </button>
    </div>
  </div>
  
  <div class="community-filters rounded-corners-12 bg-white mb-sm-3 py-3 mb-3 container-shadow" *ngIf="!showCommunity && [publicCommunityPage].indexOf(currentPage) === numbers.MINUS_ONE">
    <div class="px-3 py-1" (click)="showFilter()">
      <span class="heading-4"><span class="color-grey-700">{{mls.languageText.community.key40}}</span></span>
      <img class="filter-width" *ngIf="isMobile"  src="assets/images/filter_icon.svg" alt="filter icon">
      <span *ngIf="isMobile" class="float-right">
        <img *ngIf="!showfilter" src="assets/images/events/down-arrow.svg" alt="down arrow">
        <img *ngIf="showfilter" src="assets/images/events/up-arrow.svg" alt="up arrow">
      </span>
    </div>
    <div class="px-3">
      <ul *ngIf="showfilter && isMobile || isMobile === false">
        <ng-container *ngFor="let filter of activeFilters">
          <li>
            <label class="list-item radio w-100" [for]="filter.id">
              <input class="d-none" 
                [id]="filter.id" 
                type="radio" 
                name="list-for" 
                [checked]="setDefaultFilter === filter.checked" 
                [value]="filter.value" 
                (change)="onItemChange($event)" />
              <span>{{filter.labelText}}</span>
            </label>
           
            <!-- <label class="label-text cursor-pointer" [for]="filter.id">{{filter.labelText}}</label> -->
          </li>
        </ng-container>
      </ul>
    </div>
  </div>